"use client";

import { cn } from "@/lib/utils";
import {
  MEDIA_KINDS,
  MEDIA_KIND_LABELS,
  type MediaKind,
  type MediaLibraryFilter,
} from "@/lib/media-library-filter";
import { MEDIA_KIND_ICONS } from "./media-utils";

interface MediaFacetRailProps {
  filter: MediaLibraryFilter;
  counts: Record<MediaKind, number>;
  onSelectKind: (kind?: MediaKind) => void;
}

const RailButton = ({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: React.ReactNode;
}) => (
  <button
    type="button"
    onClick={onClick}
    className={cn(
      "flex w-full items-center gap-2 rounded-md px-2 py-1.5 text-left text-[13px] transition-colors",
      active ? "bg-gray-100 font-medium text-foreground" : "text-muted-foreground hover:bg-gray-50",
    )}
  >
    {children}
  </button>
);

export const MediaFacetRail = ({ filter, counts, onSelectKind }: MediaFacetRailProps) => (
  <aside className="flex w-52 shrink-0 flex-col gap-5 overflow-y-auto border-r bg-white px-3 py-4">
    <div className="flex flex-col gap-0.5">
      <h3 className="px-2 pb-1 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
        Type
      </h3>
      <RailButton active={!filter.kind} onClick={() => onSelectKind(undefined)}>
        <span className="truncate">All types</span>
      </RailButton>
      {MEDIA_KINDS.map((kind) => {
        const Icon = MEDIA_KIND_ICONS[kind];
        return (
          <RailButton
            key={kind}
            active={filter.kind === kind}
            onClick={() => onSelectKind(filter.kind === kind ? undefined : kind)}
          >
            <Icon className="h-3.5 w-3.5 shrink-0" />
            <span className="truncate">{MEDIA_KIND_LABELS[kind]}</span>
            <span className="ml-auto text-[11px] tabular-nums text-muted-foreground">
              {counts[kind] ?? 0}
            </span>
          </RailButton>
        );
      })}
    </div>
  </aside>
);
